import { render, staticRenderFns } from "./NotSupportedBrowser.vue?vue&type=template&id=21b8dc24&scoped=true&"
import script from "./NotSupportedBrowser.vue?vue&type=script&lang=js&"
export * from "./NotSupportedBrowser.vue?vue&type=script&lang=js&"
import style0 from "./NotSupportedBrowser.vue?vue&type=style&index=0&id=21b8dc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8dc24",
  null
  
)

export default component.exports